export default defineNuxtRouteMiddleware((to) => {
 
  const userStore = usePropertyUserStore()

  const path = to.fullPath

  if (!userStore.isAuthenticated) {
    userStore.restore()
  }


  if (!userStore.isAuthenticated) {
    if (path.startsWith('/property-manager') && !path.startsWith('/property-manager/login') ) {
      return navigateTo('/property-manager/login')
    }
  }

  if(userStore.isAuthenticated && (localStorage.getItem('PROPERTY_ID') || '') === '' && path.startsWith('/property-manager') && !path.startsWith('/property-manager/prop-002')) {
    return navigateTo('/property-manager/prop-002')
  }
  return;
});
